import React from 'react';
import Accordion from 'common/components/UI/according/Accordion';
import style from './Style.module.css';
import { useWindowSize } from 'usehooks-ts';
import Skeleton from 'common/components/npm/skeleton/Skeleton';
import clsx from 'clsx';
interface props {
  title: string;
  line?: boolean;
  data?: Data<News[]>;
}
const FAQ = ({ title, line, data }: props) => {
  const { width } = useWindowSize();


  return (
    <section className={clsx('bg-white xl:pb-[6rem]', line && style['line'])}>
      <h2
        className='py-[1.5rem] text-center text-[2.4rem] 
      font-bold md:py-[3.6rem] md:text-[2.7rem] xl:text-[4.2rem]'
      >
        {title}
      </h2>
      <div className='container'>
        <div className='md:px-10 xl:px-[15rem]'>
          {data
            ? data?.items?.map((item) => (
                <Accordion
                  key={item.id}
                  title={item.title}
                  description={item.shortDescription}
                  href={'/help/' + item.id}
                />
              ))
            : [...Array(7)].map((_, index) => (
                <Skeleton className='my-6 h-10 rounded-2' key={index} />
              ))}
        </div>
      </div>
      {width > 1280 && (
        <>
          <div
            className='absolute top-[5%] left-[6%] h-[1rem] w-[1rem] rounded-full
      bg-blue20 
      '
          ></div>
          <div
            className='absolute top-[23%] right-[1%] h-[1rem] w-[1rem]
      rounded-full bg-blue10'
          ></div>
          <div
            className='absolute top-[43%] left-[3%] h-[1rem] w-[1rem]
      rounded-full bg-blue20'
          ></div>
          <div
            className='absolute top-[60%] right-[3%] h-[1rem] w-[1rem]
      rounded-full bg-blue20'
          ></div>
          <div
            className='absolute bottom-[18%] right-[4%] h-[1rem] w-[1rem]
      rounded-full bg-blue20'
          ></div>
        </>
      )}
    </section>
  );
};

export default FAQ;
